export enum sortOrderEnum {
  ascending,
  descending
}
export enum propertyTypeEnum {
  string,
  number,
  date
}
